import { render, staticRenderFns } from "./DataTableWidget.component.html?vue&type=template&id=5bc0ce3e&scoped=true&"
import script from "./DataTableWidget.component.ts?vue&type=script&lang=ts&"
export * from "./DataTableWidget.component.ts?vue&type=script&lang=ts&"
import style0 from "./DataTableWidget.component.scss?vue&type=style&index=0&id=5bc0ce3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0ce3e",
  null
  
)

export default component.exports